export { convertInvoiceImagesToPdf } from "utils/pdfUtils";

export const MAX_INVOICE_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const INVOICE_UPLOAD_TYPES = {
  images: "images",
  pdf: "pdf",
};

const isJpeg = (file) =>
  ["image/jpeg", "image/jpg"].includes(file?.type) ||
  /\.jpe?g$/i.test(file?.name || "");

const isPng = (file) =>
  file?.type === "image/png" || /\.png$/i.test(file?.name || "");

export const isSupportedInvoiceImage = (file) => isJpeg(file) || isPng(file);

export const isSupportedInvoicePdf = (file) =>
  file?.type === "application/pdf" || /\.pdf$/i.test(file?.name || "");

export const createInvoiceDraft = (id) => ({
  client_id: id,
  upload_type: "",
  files: [],
  invoice_number: "",
  invoice_amount: "",
  weight_in_kg: "",
  number_of_sku: "",
});

export const mapDeletedInvoiceToRequest = (invoice) => ({
  vendor_invoice_id: Number(invoice.vendor_invoice_id),
  invoice_number: invoice.invoice_number,
  invoice_path: invoice.invoice_image_url,
  invoice_amount: Number(invoice.invoice_amount) || 0,
  weight_in_kg: Number(invoice.weight_in_kg) || 0,
  number_of_sku: Number(invoice.number_of_skus) || 0,
  action: "DELETE",
});

export const mapNewInvoiceToRequest = (invoice, invoicePath) => ({
  invoice_number: invoice.invoice_number.trim(),
  invoice_path: invoicePath,
  invoice_amount: Number(invoice.invoice_amount),
  weight_in_kg: Number(invoice.weight_in_kg),
  number_of_sku: Number(invoice.number_of_sku),
  action: "UPSERT",
});

export const getInvoiceErrorMessage = (error, fallbackMessage) => {
  const internalError = error?.response?.data?.error?.internal_error;
  if (internalError) {
    const match = internalError.match(/OrignalError\s*:\s*(.+?),\s*ErrorType/);
    if (match) return match[1].trim();
  }
  return (
    error?.response?.data?.error?.message || error?.message || fallbackMessage
  );
};
